import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export function PdfViewer({ document }) {
  const [numPages, setNumPages] = React.useState(null);
  const [pdfData, setPdfData] = React.useState(null);

  React.useEffect(() => {
    if (!document?.data) return;

    const loadPdf = async () => {
      try {
        const buffer = await document.data.arrayBuffer();
        setPdfData(new Uint8Array(buffer));
      } catch (err) {
        console.error("Gagal load PDF:", err);
      }
    };

    loadPdf();
  }, [document]);

  const file = React.useMemo(
    () => (pdfData ? { data: pdfData } : null),
    [pdfData]
  );

  const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages);

  return (
    <div style={{ overflow: 'auto', maxHeight: 500 }}>
      {file ? (
        <Document
          file={file}
          onLoadSuccess={onDocumentLoadSuccess}
          loading="Loading PDF..."
        >
          {Array.from(new Array(numPages), (el, index) => (
            <div
              key={`wrapper_${index + 1}`}
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: 16,
              }}
            >
              <Page
                pageNumber={index + 1}
                width={800}
              />
            </div>
          ))}
        </Document>
      ) : (
        <p>Preparing your document..</p>
      )}
    </div>
  );
}
